// apps/smart-shikka-web/src/pages/chat/SupportActions.tsx
// CORE-HELP-02: post-answer support actions — shown only on support-ish turns (§6).
// Server does its own triage on the ticket create; this heuristic only decides
// whether the affordance renders.
import { useBrandColors } from "@smart-shikka/react";

const SUPPORT_TURN_RE =
  /(help|problem|error|issue|stuck|fail|broken|support|ticket|मदद|समस्या|सहायता|दिक्कत|परेशानी|त्रुटि|कैसे|काम नहीं|नहीं हो|fix|bug)/i;

export function isSupportTurn(query: string): boolean {
  return SUPPORT_TURN_RE.test(query);
}

const EXPLICIT_HUMAN_RE =
  /(human|agent|सच्चे इंसान|real person|सपोर्ट टीम|किसी से बात|इंसान से|मानव)/i;

export function isExplicitHumanRequest(query: string): boolean {
  return EXPLICIT_HUMAN_RE.test(query);
}

export function SupportActionsCard({
  busy,
  ticketNumber,
  onSolved,
  onHumanHelp,
  onHelpCenter,
}: {
  busy: boolean;
  ticketNumber?: string | undefined;
  onSolved: () => void;
  onHumanHelp: () => void;
  onHelpCenter: () => void;
}) {
  const C = useBrandColors();
  if (ticketNumber) {
    return (
      <div
        role="status"
        style={{
          display: "flex", alignItems: "center", gap: 10, marginTop: 8,
          padding: "8px 12px", borderRadius: 8, border: `1px solid ${C.border}`,
          background: C.card, fontSize: 11, color: C.fg,
        }}
      >
        <span>टिकट {ticketNumber} सपोर्ट टीम को भेजा गया।</span>
        <button
          type="button"
          onClick={onHelpCenter}
          style={{ border: "none", background: "transparent", color: C.accentFg, fontSize: 11, fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}
        >
          मेरे टिकट देखें →
        </button>
      </div>
    );
  }
  return (
    <div
      role="status"
      style={{
        display: "flex", alignItems: "center", gap: 8, marginTop: 8,
        padding: "8px 12px", borderRadius: 8, border: `1px solid ${C.border}`,
        background: C.card, fontSize: 11, color: C.muted, flexWrap: "wrap",
      }}
    >
      <span>क्या समस्या हल हुई?</span>
      <button
        type="button"
        disabled={busy}
        onClick={onSolved}
        style={{ padding: "4px 10px", borderRadius: 6, border: `1px solid ${C.border}`, background: "transparent", color: C.fg, fontSize: 11, cursor: "pointer" }}
      >
        हाँ, हल हो गया
      </button>
      <button
        type="button"
        disabled={busy}
        onClick={onHumanHelp}
        style={{ padding: "4px 10px", borderRadius: 6, border: `1px solid ${C.border}`, background: C.accent, color: C.accentFg, fontSize: 11, fontWeight: 600, cursor: "pointer" }}
      >
        मानव सहायता चाहिए
      </button>
    </div>
  );
}
